import { render, staticRenderFns } from "./ControlsDesktop.vue?vue&type=template&id=930198e0&scoped=true&"
import script from "./ControlsDesktop.vue?vue&type=script&lang=js&"
export * from "./ControlsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ControlsDesktop.vue?vue&type=style&index=0&id=930198e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930198e0",
  null
  
)

export default component.exports